import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card border-0 rounded-3 mb-4",
  style: {"background":"linear-gradient(120deg, #343a46 0%, #23272e 99.29%)"}
}
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-51px 0 -5px 0"} }
const _hoisted_4 = {
  ref: "incomeSource",
  style: {"width":"300px","height":"250px"},
  class: "mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 mb-4" }, [
        _createElementVNode("h3", { class: "fs-18 mb-0 text-white" }, "Income Source"),
        _createElementVNode("span", { class: "fs-12 text-white" }, "Last 30 days")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, null, 512)
      ])
    ])
  ]))
}